export const AuthenticationConstants = {
  APPLICANT_TOKEN: 'applicant_token',
  USER_TOKEN: 'user_token',
  APPLICANT_EXPIRES_AT: 'applicant_expires_at',
  USER_EXPIRES_AT: 'user_expires_at',
}
